<template>
  <div>
    <div
      @click="showContext = !showContext"
      ref="contextButton"
      class="context-opener friends-context-opener"
      :class="{ 'context-opener-open': showContext }"
    ></div>
    <ul
      v-if="showContext"
      v-click-outside="{
        exclude: ['contextButton'],
        handler: 'clickOutsideContext',
      }"
      class="context friends-context"
    >
      <li v-if="iAmBlocked" @click="showWarning" class="context-item">
        {{ $t("myFriends.writeMessage") }}
      </li>
      <redirectButton
        v-else
        tag="li"
        pathname="threads"
        :params="{ id: id }"
        :html="$t('myFriends.writeMessage')"
        class="context-item"
      ></redirectButton>
      <li @click="$modal.show('gifts-list', { id: id })" class="context-item">
        {{ $t("myFriends.sendGift") }}
      </li>
      <li
        v-if="removeAvailable"
        @click="remove(id)"
        class="context-item link-red"
      >
        {{ $t("myFriends.removeFriends") }}
      </li>
      <li
        v-if="!removeAvailable"
        @click="cancelAddFriends(id)"
        class="context-item"
      >
        {{ $t("myFriends.cancelRequest") }}
      </li>
    </ul>
  </div>
</template>

<script>
import redirectButton from "@/components/Buttons/Redirect";
import { clickOutside } from "@/directives.js";

export default {
  name: "FriendsContext",
  props: {
    i18n: Object,
    id: {
      type: Number,
      required: true,
    },
    removeAvailable: {
      type: Boolean,
      required: true,
    },
    iAmBlocked: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    redirectButton,
  },
  data() {
    return {
      showContext: false,
    };
  },
  methods: {
    remove(id) {
      this.$store.dispatch("friends/remove", id).then(() => {
        this.showContext = false;
        this.$modal.show("dialog", {
          title: this.$t("myFriends.success"),
          text: this.$t("roulette.ok"),
          buttons: [
            {
              title: this.$t("myFriends.friendSuccessfullyDeleted"),
            },
          ],
        });
      });
    },
    cancelAddFriends(id) {
      this.$store.dispatch("friendsOutgoing/cancelAddFriends", id).then(() => {
        this.showContext = false;
        this.$modal.show("dialog", {
          title: this.$t("myFriends.success"),
          text: this.$t("myFriends.applicationCancelled"),
          buttons: [
            {
              title: this.$t("roulette.ok"),
            },
          ],
        });
      });
    },
    clickOutsideContext() {
      this.showContext = false;
    },
    showWarning() {
      this.showContext = false;
      this.$modal.show("dialog", {
        title: this.$t("threads.mistake"),
        text: this.$t("myFriends.userRestrictedMessages"),
        buttons: [
          {
            title: this.$t("roulette.ok"),
          },
        ],
      });
    },
  },
};
</script>
